/* @flow */

import { type State } from './types';

export const loadState = (): ?State => {
    const serializedState = localStorage.getItem('preact-app-state');
    if (!serializedState) {
        return null;
    }

    try {
        return JSON.parse(serializedState);
    } catch (err) {
        return null;
    }
};

export const saveState = (state: Object) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('preact-app-state', serializedState);
    } catch (err) {
        // ignorar
    }
};

export const deleteState = () => {
    localStorage.removeItem('preact-app-state');
};
